import { TFileMessageOutputDto } from "@/api/services/admin/conversation/dtos/create-message.dto";
import { IconFile } from "@/assets/icons";
import { text } from "@/theme/colors";
import { textEllipsis } from "@/theme/minxin";
import { typography } from "@/theme/typography";
import { Box, Stack, StackProps, Typography, styled } from "@mui/material";
import { FC } from "react";

type TMessageFileInfoProps = {
  file: TFileMessageOutputDto;
  side: "left" | "right";
} & StackProps;

export const MessageFileInfo: FC<TMessageFileInfoProps> = ({ file, side, ...rest }) => {
  return (
    <Stack {...rest} gap={0.5}>
      <Stack direction="row" alignItems="center">
        <FileItemWrap>
          <IconFile fontSize="32px" />
          <FileName side={side}>{file.name}</FileName>
        </FileItemWrap>
      </Stack>
    </Stack>
  );
};

const FileItemWrap = styled(Box)`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
  margin-right: 4px;
`;

const FileName = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "side",
})<{ side: "left" | "right" }>`
  ${textEllipsis};
  ${typography.body14};
  flex: 1;
  color: ${({ side }) => (side === "left" ? text.primary : "#fff")};
`;
